<div class="modal-content p-4">
  <div class="col-12 custom-box p-5">
    <header id="header" class="row align-items-center justify-content-between sticky-header">
      <div class="left-section">
        <span class="back-button" (click)="closeModal()">
          <i class="fas fa-angle-left"></i> Voltar
        </span>
      </div>
      <h3 class="form-title text-center">Editar Credor Pessoa Jurídica</h3>
      <div class="right-section">
        <button class="btn" (click)="updateEmpresa()">Atualizar</button>
      </div>
    </header>
        <form [formGroup]="formEmpresa">
          <div id="formEmpresas" class="form-group">
                <div class="col-12 p-3 text-center">
                  <p class="custom-box-subtitle">
                    <i class="fas fa-info-circle"></i>
                    O Representante Legal indicado deve possuir poderes de representação para assinar o termo em nome do Credor Pessoa Jurídica, de acordo com a documentação Societária e Procuração (se houver) a ser enviada.
                  </p>
                </div>
              <div class="form-row mt-3">
                <div class="form-group col-6">
                  <label class="form-label" >CNPJ</label>
                  <input formControlName="cnpj" autocomplete="off" mask="AA.AAA.AAA/AAAA-AA" class="form-control form-adaptable form-icon-trailing"/>
                </div>
                <div class="form-group col-6">
                  <label class="form-label" >Razão Social <b class="text-danger">*</b></label>
                  <input formControlName="nomeEmpresa" autocomplete="off" maxlength="150" class="form-control form-adaptable form-icon-trailing" />
                  <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('required') && (formEmpresa.get('nomeEmpresa').dirty || formEmpresa.get('nomeEmpresa').touched)">Campo obrigatório.</span>
                  <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
                </div>
                <div class="form-group col-6">
                  <span class="info-text"><i class="fas fa-info-circle"></i> Campo não editável</span>
                </div>
              </div>
              <hr>

              <div formArrayName="representantes">
                <div *ngFor="let rep of representantes.controls; let i = index" [formGroupName]="i">
                  <h2 class="title-section"><i class="fas fa-edit"></i>
                      Representante Legal {{ i + 1}}
                      <span class=" badge badge-solid" *ngIf="i === 0">Obrigatório</span>
                      <span class=" badge badge-outline" *ngIf="i === 1">Se aplicável</span>
                    </h2>
                  <div class="form-row mt-3">
                    <div class="form-group col-12">
                      <label class="form-label" >Nome Completo <b class="text-danger" *ngIf="i === 0">*</b></label>
                      <input formControlName="nome" autocomplete="off-" maxlength="150" placeholder="Nome Completo" class="form-control form-adaptable form-icon-trailing" />
                      <span class="error-form ml-2" *ngIf="rep.get('nome').hasError('required') && (rep.get('nome').dirty || rep.get('nome').touched)">Campo obrigatório.</span>

                    </div>
                    <div class="form-group col-6">
                      <label class="form-label" >CPF <b class="text-danger" *ngIf="i === 0">*</b></label>
                      <input formControlName="cpf" autocomplete="off" placeholder="000.000.000-00" mask="000.000.000-00" class="form-control form-adaptable form-icon-trailing" />
                      <span class="error-form ml-2" *ngIf="rep.get('cpf').hasError('required') && (rep.get('cpf').dirty || rep.get('cpf').touched)">Campo obrigatório.</span>
                    </div>
                    <div class="form-group col-6">
                      <label class="form-label" >E-mail <b class="text-danger" *ngIf="i === 0">*</b></label>
                      <input formControlName="emailPj" autocomplete="off-" placeholder="exemplo@exemplo.com" class="form-control form-adaptable form-icon-trailing" />
                      <span class="error-form ml-2" *ngIf="rep.get('emailPj').hasError('required') && (rep.get('emailPj').dirty || rep.get('emailPj').touched)">Campo obrigatório.</span>
                      <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                    </div>
                  </div>
                </div>
              </div>



          </div>
        </form>
  </div>
</div>
